import React from "react";
import PropTypes from "prop-types";

import { Frame } from "@bitesite/react-figstrap";
import { Input, Select } from "../../../odc-ui";
import styled from "styled-components/macro";
import { monthOptions, dayOptions } from "../../../utilities/select_options";

const DateOfBirthSelectConatiner = styled.div`
  width: calc(100% - 5px);
`;

const UserFields = ({
  prompt,
  enabledFields,
  firstName,
  onFirstNameChange,
  lastName,
  onLastNameChange,
  email,
  onEmailChange,
  phone,
  onPhoneChange,
  selectedDateOfBirthMonthOption,
  onSelectedDateOfBirthMonthOptionChange,
  selectedDateOfBirthDayOption,
  onSelectedDateOfBirthDayOptionChange,
}) => {
  return (
    <Frame vertical gap={10}>
      <div>{prompt}</div>
      <Frame vertical gap={10}>
        {enabledFields.includes("firstName") && (
          <Input
            type="text"
            placeholder="First Name"
            value={firstName}
            onChange={(e) => onFirstNameChange(e.target.value)}
          />
        )}
        {enabledFields.includes("lastName") && (
          <Input
            type="text"
            placeholder="Last Name"
            value={lastName}
            onChange={(e) => onLastNameChange(e.target.value)}
          />
        )}
        {enabledFields.includes("email") && (
          <Input
            type="text"
            placeholder="Email"
            value={email}
            onChange={(e) => onEmailChange(e.target.value)}
          />
        )}
        {enabledFields.includes("phone") && (
          <Input
            type="text"
            placeholder="Phone"
            value={phone}
            onChange={(e) => onPhoneChange(e.target.value)}
          />
        )}
        {enabledFields.includes("dateOfBirth") && (
          <Frame vertical>
            <div>Birthday</div>
            <Frame gap={10}>
              <DateOfBirthSelectConatiner>
                <Select
                  value={selectedDateOfBirthMonthOption}
                  options={monthOptions}
                  onChange={onSelectedDateOfBirthMonthOptionChange}
                />
              </DateOfBirthSelectConatiner>
              <DateOfBirthSelectConatiner>
                <Select
                  value={selectedDateOfBirthDayOption}
                  options={dayOptions}
                  onChange={onSelectedDateOfBirthDayOptionChange}
                />
              </DateOfBirthSelectConatiner>
            </Frame>
          </Frame>
        )}
      </Frame>
    </Frame>
  );
};

UserFields.propTypes = {
  prompt: PropTypes.string.isRequired,
  enabledFields: PropTypes.arrayOf(PropTypes.string).isRequired,
  firstName: PropTypes.string,
  onFirstNameChange: PropTypes.func.isRequired,
  lastName: PropTypes.string,
  onLastNameChange: PropTypes.func.isRequired,
  email: PropTypes.string,
  onEmailChange: PropTypes.func.isRequired,
  phone: PropTypes.string,
  onPhoneChange: PropTypes.func.isRequired,
  selectedDateOfBirthMonthOption: PropTypes.object,
  onSelectedDateOfBirthMonthOptionChange: PropTypes.func.isRequired,
  selectedDateOfBirthDayOption: PropTypes.object,
  onSelectedDateOfBirthDayOptionChange: PropTypes.func.isRequired,
};

export default UserFields;
